import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, mergeMap, withLatestFrom } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { EMPTY, of } from 'rxjs';
import { FaxeStore } from '@app/store/faxe/faxe-store-model';
import { onOperationStatus } from '../../client-slices/operation/operation.actions';
import {
  addManyRiderEvents,
  fetchAllRiderEvents,
  getRiderEvents
} from '@app/store/faxe/rider-event/rider-event.actions';
import { selectRidersEventState } from '@app/store/faxe/rider-event/rider-event.selectos';
import { push } from '@app/fremework/functions';
import { notEmptyByRaceSliceState } from '@app/domain/functions';
import { SliceState } from '@app/store/faxe/sapiens-entity-state';
import { RiderEventsService } from '@app/rest-client/faxe/services/rider-events.service';

@Injectable()
export class RiderEventEffects {

  entity = 'RiderEvent';

  fetchRiderEventEffect = createEffect(() => this.actions$
    .pipe(
      ofType(fetchAllRiderEvents),
      mergeMap(action =>
        this.store.select(selectRidersEventState())
          .pipe(
            withLatestFrom(of(action)),
            mergeMap(([state, action]) => {

              if (notEmptyByRaceSliceState(
                state.riderEvents,
                action.raceGuid,
                action.requiredSliceState,
                state.sliceState)) {
                return EMPTY;
              }

              const actions = [];
              actions.push(getRiderEvents({
                raceGuid: action.raceGuid,
                requiredSliceState: action.requiredSliceState,
                issuerStack: push(action.issuerStack, 'fetchRiderEventEffect')
              }));
              return of(...actions);
            })
          )
      ),
      catchError(() => EMPTY)
    )
  );

  getRiderEventEffect = createEffect(() =>
    this.actions$.pipe(
      ofType(getRiderEvents),
      exhaustMap((action) =>
          this.service.riderEventsOnlyReportable({raceGuid: action.raceGuid, onlyReportable: action.requiredSliceState !== SliceState.total})
          .pipe(mergeMap((response) => {
              const actions = [];
              actions.push(addManyRiderEvents(
                {
                  models: response,
                  sliceState: action.requiredSliceState,
                  issuerStack: push(action.issuerStack, `get${this.entity}Effect`)
                }));
              return of(...actions);
            }),
            catchError((e) =>
              of(onOperationStatus({
                  model: {
                    status: e.status,
                    operationId: 'getRiderEventEffect',
                    callStack: push(action.issuerStack, 'getRiderEventEffect')
                  }
                })
              )
            )
          )),
      catchError(() => EMPTY)
    )
  );

  constructor(
    private service: RiderEventsService,
    private actions$: Actions,
    private store: Store<FaxeStore>
  ) {
  }
}
